"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiDefaultBigWin = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _PixiAnimatedParticleEmitter = require("./particles/PixiAnimatedParticleEmitter");
var _PixiWinParticlesCombined = require("./particles/PixiWinParticlesCombined");
var _pixiGame = require("@dragon/pixi-game");
var _PixiWinParticlesConstants = require("./particles/PixiWinParticlesConstants");
var _gsap = _interopRequireDefault(require("gsap"));
var _PixiSpineAnimation = require("./PixiSpineAnimation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiDefaultBigWin = exports.PixiDefaultBigWin = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiDefaultBigWin(name, bitmapFontName) {
    var _this;
    var backdropColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0x5e5e5e;
    var bgAlpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.7;
    _classCallCheck(this, PixiDefaultBigWin);
    _this = _callSuper(this, PixiDefaultBigWin, [name]);
    _defineProperty(_this, "COUNT_DURATION", 5);
    _defineProperty(_this, "bg", void 0);
    _defineProperty(_this, "container", void 0);
    _defineProperty(_this, "_counter", void 0);
    _defineProperty(_this, "_maxWin", void 0);
    _defineProperty(_this, "_coinsWon", void 0);
    _defineProperty(_this, "_resolve", void 0);
    /**for speed throug */
    _defineProperty(_this, "clickCount", 0);
    _defineProperty(_this, "_coinShower1", void 0);
    _defineProperty(_this, "_flare", void 0);
    _defineProperty(_this, "_coin1Interval", void 0);
    _defineProperty(_this, "_coin2Interval", void 0);
    _defineProperty(_this, "_coin3Interval", void 0);
    _defineProperty(_this, "tlBigWin", void 0);
    _defineProperty(_this, "_level", void 0);
    _defineProperty(_this, "_headerMaxWidth", void 0);
    _defineProperty(_this, "_gemPuffer", void 0);
    _defineProperty(_this, "_bwAnim", void 0);
    _defineProperty(_this, "_counterSteps", void 0);
    _defineProperty(_this, "_content", void 0);
    _defineProperty(_this, "_counterTween", void 0);
    _defineProperty(_this, "_counterScaleTween", void 0);
    _defineProperty(_this, "buildTimeline", function () {
      _this.tlBigWin = _gsap["default"].timeline({
        paused: true
      });
      var counter = {
        value: 0
      };
      _this.tlBigWin.add("p2start", 0).add(function () {
        _this.onStart();
        _this.onPhaseChange(1);
        _this.clickCount = 0;
        _this._counter.text = "";
        _this.visible = true;
        _this.bg.visible = true;
        _gsap["default"].to(_this, 0.5, {
          alpha: 1,
          duration: 0.5
        });
        _gsap["default"].to(_this.bg, 0.5, {
          alpha: 0.7,
          duration: 0.5
        });

        //#region handle scale on text etc.

        _this._counter.text = (0, _core.coinsToCurrency)(_this._coinsWon, undefined, undefined, undefined, undefined, true);
        if (_this._headerMaxWidth && _this._counter.width / _this._counter.scale.x >= _this._headerMaxWidth - 40) {
          _this._counter.scale.set((_this._headerMaxWidth - 40) / (_this._counter.width / _this._counter.scale.x));
        }
        //#endregion
        //start flare animation
        _this._flare.state.setAnimation(0, "loop", true);
        _this._bwAnim.state.setAnimation(0, '1_appear', false);
        _this._bwAnim.state.addAnimation(0, '1_play', true, 0);
        _this._coinShower1.start(0.04);
        //    this._coinShower2.start(0.1);
        _this._coin1Interval = setInterval(function () {
          _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Game, false, 'coins2', 1));
        }, 350);
        _this._coin2Interval = setInterval(function () {
          _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Game, false, 'coins3', 0.6));
        }, 400);
        _this._coin3Interval = setInterval(function () {
          _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Game, false, 'coins1', 0.5));
        }, 620);
        _this._counterScaleTween = _gsap["default"].to(_this._counter.scale, {
          duration: 0.6,
          x: _this._counter.scale.x * 1.10,
          y: _this._counter.scale.y * 1.10,
          yoyo: true,
          repeat: -1
        });
        counter.value = 0;
        _this._counterSteps = [];
        switch (_this._level) {
          case 1:
            {
              _this._counterSteps = [_this._coinsWon, _this._coinsWon, _this._coinsWon];
              break;
            }
          case 2:
            {
              _this._counterSteps = [_this._coinsWon * 0.5, _this._coinsWon, _this._coinsWon];
              break;
            }
          default:
            {
              _this._counterSteps = [_this._coinsWon * 0.33, _this._coinsWon * 0.66, _this._coinsWon];
              break;
            }
        }
        _this._counterTween = _gsap["default"].to(counter, {
          duration: _this.COUNT_DURATION,
          value: _this._counterSteps[0],
          ease: 'power1.in',
          onUpdate: function onUpdate() {
            _this._counter.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
          }
        });
      }, "p2start").add("p2startSuper", "+=5").add(function () {
        //   console.log('p2startSuper')
        _this.clickCount = 1;
        if (_this._level == 1) _this.tlBigWin.seek("p3start", true);else {
          var _this$_counterTween;
          _this.onPhaseChange(2);
          _this._bwAnim.state.addAnimation(0, '2_appear', false, 0);
          _this._bwAnim.state.addAnimation(0, '2_play', true, 0);
          (_this$_counterTween = _this._counterTween) === null || _this$_counterTween === void 0 || _this$_counterTween.kill();
          counter.value = _this._counterSteps[0];
          _this._counter.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
          _this._counterTween = _gsap["default"].to(counter, {
            duration: _this.COUNT_DURATION,
            value: _this._counterSteps[1],
            ease: 'none',
            onUpdate: function onUpdate() {
              _this._counter.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
            }
          });
        }
      }, "p2startSuper").add("p2startMega", "+=5").add(function () {
        _this.clickCount = 2;
        //    console.log('p2startMega')
        if (_this._level == 1 || _this._level == 2) _this.tlBigWin.seek("p3start", true);else {
          var _this$_counterTween2;
          _this.onPhaseChange(3);
          _this._bwAnim.state.addAnimation(0, '3_appear', false, 0);
          _this._bwAnim.state.addAnimation(0, '3_play', true, 0);
          (_this$_counterTween2 = _this._counterTween) === null || _this$_counterTween2 === void 0 || _this$_counterTween2.kill();
          counter.value = _this._counterSteps[1];
          _this._counter.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
          _this._counterTween = _gsap["default"].to(counter, {
            duration: _this.COUNT_DURATION,
            value: _this._counterSteps[2],
            ease: 'none',
            onUpdate: function onUpdate() {
              _this._counter.text = (0, _core.coinsToCurrency)(counter.value, undefined, undefined, undefined, undefined, true);
            }
          });
        }
      }, "p2startMega").to([_this._flare], 2, {
        alpha: 0.6
      }, "p2start").add("p3start", "+=5").add(function () {
        //   console.log('p3start')
        _this.clickCount = 3;
        _this._coinShower1.stop();
        _this.onPhaseChange(4);
        clearInterval(_this._coin1Interval);
        clearInterval(_this._coin2Interval);
        clearInterval(_this._coin3Interval);
        _this._counterTween.kill();
        _this._counter.text = (0, _core.coinsToCurrency)(_this._coinsWon, undefined, undefined, undefined, undefined, true);
      }, "p3start").add("p4start", "+=10").add(function () {
        _this.onPhaseChange(5);
        //  console.log('p4start')
        _this.clickCount = 4;
        _this._counterScaleTween.kill();
        _gsap["default"].to(_this, {
          duration: 0.5,
          alpha: 0,
          onComplete: function onComplete() {
            _this.visible = false;
          }
        });
        _gsap["default"].to(_this.bg, {
          duration: 0.5,
          alpha: 0,
          onComplete: function onComplete() {
            _this.bg.visible = false;
          }
        });
        _this.onStop();
        _this._resolve();
      }, "p4start");
    });
    _defineProperty(_this, "onClick", function (t) {
      _this.clickCount++;
      if (_this.clickCount == 1) {
        _this.tlBigWin.seek("p2startSuper", false);
      } else if (_this.clickCount == 2) {
        _this.tlBigWin.seek("p2startMega", false);
      } else if (_this.clickCount == 3) {
        _this.tlBigWin.seek("p3start", false);
      } else if (_this.clickCount == 4) {
        _this.tlBigWin.seek("p4start", false);
      }
    });
    _this._content = new _pixi.Container();
    _this.visible = false;
    _this.alpha = 0;
    var bg = new _pixi.Graphics();
    bg.beginFill(backdropColor);
    bg.drawRoundedRect(0, 0, 100, 100, 0);
    bg.alpha = 0.7;
    var texture = _this.application.renderer.generateTexture(bg, {
      resolution: 1,
      scaleMode: _pixi.SCALE_MODES.LINEAR
    });
    _this.bg = new _pixi.Sprite(texture);
    _this.bg.anchor.set(0.5);
    _this.bg.alpha = 0.7;
    _this.bg.visible = true;
    _this.addChild(_this.bg);
    _this._flare = new _PixiSpineAnimation.PixiSpineAnimation("bigwin_flare_animation");
    _this._flare.scale.set(1.5);
    _this._flare.alpha = 0.5;
    _this._flare.position.y = 0;
    _this._content.addChild(_this._flare);
    // not click/touch event is on bg, not on 
    _this.bg.interactive = true;
    _this.bg.on('pointerdown', _this.onClick);
    _this._counter = new _pixiGame.CustomBitmapText('', {
      fontName: bitmapFontName,
      fontSize: 100,
      letterSpacing: -10
    });
    _this._counter.anchor.set(0.5, 0.5);

    //#region ANIMATION
    _this._bwAnim = new _PixiSpineAnimation.PixiSpineAnimation("bigwin_anim");
    _this._bwAnim.x = 0;
    _this._bwAnim.y = -23;
    var eventHandler = {
      start: function start(entry) {
        // console.log('STARTED ' + entry.animation.name)
        switch (entry.animation.name) {
          case '1_appear':
            _this._gemPuffer.puffAll(500, 0.08);
            break;
          case '2_appear':
            _this._gemPuffer.puffAll(500, 0.04);
            break;
          case '3_appear':
            _this._gemPuffer.puffAll(500, 0.02);
            break;
        }
      },
      end: function end(entry) {}
    };
    _this._bwAnim.state.addListener(eventHandler);

    //#endregion

    //#region puffer
    _this._gemPuffer = new _PixiWinParticlesCombined.PixiWinParticlesCombined(name + 'PC', null, _PixiWinParticlesConstants.PARTICLE_TYPES, {
      "scale": {
        "start": 1.5,
        "end": 1.5,
        "minimumScaleMultiplier": 20
      },
      "speed": {
        "start": 900,
        "end": 0,
        "minimumSpeedMultiplier": 0.2
      },
      "startRotation": {
        "min": 270 - 30,
        "max": 270 + 30
      },
      "rotationSpeed": {
        "min": 0,
        "max": 720
      },
      "frequency": 0.1,
      "acceleration": {
        "x": 0,
        "y": 1100
      }
    });
    _this._content.addChild(_this._gemPuffer);
    //#endregion
    _this._content.addChild(_this._bwAnim);
    _this._content.addChild(_this._counter);

    //#region  MAX WIN
    _this._maxWin = new _pixi.BitmapText("MAXWIN", {
      fontName: bitmapFontName,
      //'bigwin',
      fontSize: 60,
      align: 'center',
      letterSpacing: -10
    });
    _this._maxWin.anchor.set(0.5, 1);
    _this._maxWin.text = _core.CORE.translate("winlevel4");
    _this._content.addChild(_this._maxWin);
    //#endregion
    _this.buildTimeline();
    _this.addChild(_this._content);
    return _this;
  }
  _inherits(PixiDefaultBigWin, _PixiGameComponent);
  return _createClass(PixiDefaultBigWin, [{
    key: "start",
    value: function start(coins, level) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        _this2.clickCount = 0;
        _this2._coinsWon = coins;
        _this2._level = level;
        if (_this2._level == 4) _this2._maxWin.visible = true;else _this2._maxWin.visible = false;
        _this2._resolve = resolve;
        _this2._counter.scale.set(1);
        _this2.tlBigWin.timeScale(1);
        _this2.tlBigWin.restart();
      });
    }
  }, {
    key: "onResize",
    value: function onResize(c) {
      if (this._coinShower1) this._coinShower1.destroy();
      this._coinShower1 = new _PixiAnimatedParticleEmitter.PixiAnimatedParticleEmitter("BwShower", _PixiWinParticlesConstants.GOLD_DOLLAR_COINS_SPRITES, {
        "scale": {
          "start": c.channel == _core.Channel.Mobile && c.orientation == _core.Orientation.Landscape ? 1.2 * c.scaleFactor : 0.8,
          "end": c.channel == _core.Channel.Mobile && c.orientation == _core.Orientation.Landscape ? 1.2 * c.scaleFactor : 0.8,
          "minimumScaleMultiplier": 1
        },
        "speed": {
          "start": 0,
          "end": c.channel == _core.Channel.Mobile && c.orientation == _core.Orientation.Landscape ? -300 : -500,
          "minimumSpeedMultiplier": 1
        },
        "spawnType": "rect",
        "spawnRect": {
          "x": 0,
          "y": -20 * c.resolution,
          "w": 1920,
          "h": 20
        }
      });
      this.addChild(this._coinShower1);
      this.bg.height = c.height;
      this.bg.width = c.width;
      this.position.set(c.width / 2, c.height / 2);
      this._headerMaxWidth = undefined;
      this._flare.position.set(0);
      switch (c.channel) {
        case _core.Channel.Desktop:
          {
            //desktop
            this._flare.position.set(0, -80);
            this._content.scale.set(c.scaleFactorHd);
            this._counter.y = 40 - 80;
            this._bwAnim.y = -180;
            this._maxWin.y = 300;
            this._coinShower1.scale.set(c.scaleFactorHd);
            this._coinShower1.x = -(c.width / 2);
            this._coinShower1.y = -(c.height / 2);
            break;
          }
        case _core.Channel.Mobile:
          {
            this._coinShower1.x = -(c.width / 2);
            this._coinShower1.y = -(c.height / 2);
            // note count scale dont work since we animate it....
            this._counter.y = 0;
            this._maxWin.y = 0;
            this._maxWin.scale.set(c.scaleFactor * 0.6);
            switch (c.orientation) {
              case _core.Orientation.Portrait:
                {
                  this._headerMaxWidth = c.width;
                  this._counter.scale.set(1);
                  this._flare.position.y = -80;
                  this._counter.y = this._counter.y - 20;
                  this._maxWin.y = this._maxWin.y + 200;
                  this._bwAnim.y = -100;
                  this._bwAnim.scale.set(c.scaleFactor * 0.6);
                  this._flare.scale.set(c.scaleFactor * 1);
                  this._gemPuffer.scale.set(c.scaleFactor * 0.5);
                  break;
                }
              case _core.Orientation.Landscape:
                {
                  this._gemPuffer.scale.set(c.scaleFactor * 0.9);
                  this._headerMaxWidth = c.height;
                  this._bwAnim.y = -50;
                  this._bwAnim.scale.set(c.scaleFactor * 1.1);
                  this._flare.position.y = -60;
                  this._flare.scale.set(c.scaleFactor * 1.5);
                  this._maxWin.y = this._maxWin.y + 200;

                  // Ipad Landscape
                  if (c.height >= 700) {
                    this._bwAnim.y = -120;
                    this._bwAnim.scale.set(c.scaleFactor * 1);
                    this._counter.fontSize = this._counter.fontSize * c.scaleFactor * 2;
                  }
                  break;
                }
            }
          }
      }
    }
  }, {
    key: "onPhaseChange",
    value: function onPhaseChange(phase) {}
  }, {
    key: "onStart",
    value: function onStart() {}
  }, {
    key: "onStop",
    value: function onStop() {}
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiDefaultBigWin.js.map